/*
document.addEventListener('_changeVariant', function(event) {
  //console.log('Variant change')
});
*/

/*
document.addEventListener('cartItems', function(event) {
  //console.log('Cart has been updated')
});
*/
document.addEventListener('DOMContentLoaded', function() {
  // Botón "-" (Restar)
  document.querySelectorAll('.btn-menos').forEach(function(boton) {
    boton.addEventListener('click', function() {
      const input = this.nextElementSibling;
      if (parseInt(input.value) > 1) {
        input.value = parseInt(input.value) - 1;
      }
    });
  });

  // Botón "+" (Sumar)
  document.querySelectorAll('.btn-mas').forEach(function(boton) {
    boton.addEventListener('click', function() {
      const input = this.previousElementSibling;
      input.value = parseInt(input.value) + 1;
    });
  });
});